export const FORM_SUBMIT_START = 'FORM_SUBMIT_START';
export const FORM_SUBMIT_END = 'FORM_SUBMIT_END';

export const formSubmitStart = () => ({
	type: FORM_SUBMIT_START
});

export const formSubmitStop = () => ({
	type: FORM_SUBMIT_END
});

export default (
	state = {
		formSubmitting: false
	},
	action
) => {
	switch (action.type) {
		case FORM_SUBMIT_START:
			return {
				formSubmitting: true
			};
		case FORM_SUBMIT_END:
			return {
				formSubmitting: false
			};
		default:
			return state;
	}
};
